import { Actions, ActionTypes } from './actions';
import { problemForUserAdapter, initialState, ProblemForUserState } from './state';

export function problemReducer(state = initialState, action: Actions): ProblemForUserState {
  switch (action.type) {
    case ActionTypes.FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    }

    case ActionTypes.LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }

    case ActionTypes.LOAD_SUCCESS: {
      return problemForUserAdapter.upsertMany(action.items, {
        ...state,
        isLoading: false,
        error: null,
      });
    }

    case ActionTypes.CREATE_SUBSCRIPTION_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }

    case ActionTypes.CREATE_SUBSCRIPTION_SUCCESS: {
      return problemForUserAdapter.upsertOne(action.problem, {
        ...state,
        isLoading: false,
        error: null,
      });
    }

    case ActionTypes.DELETE_SUBSCRIPTION_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }

    case ActionTypes.DELETE_SUBSCRIPTION_SUCCESS: {
      return problemForUserAdapter.upsertOne(action.problem, {
        ...state,
        isLoading: false,
        error: null,
      });
    }

    case ActionTypes.CREATE_LOCK_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }

    case ActionTypes.CREATE_LOCK_SUCCESS: {
      return problemForUserAdapter.upsertOne(action.problem, {
        ...state,
        isLoading: false,
        error: null,
      });
    }

    default: {
      return state;
    }
  }
}
